import { FetchData } from "services/api";

export const fetchAdminData = (params = {}, signal) => {
  const searchParams = new URLSearchParams();
  if (params.view) searchParams.set("view", params.view);
  if (params.limit) searchParams.set("limit", params.limit);
  if (params.offset !== undefined) searchParams.set("offset", params.offset);
  if (params.search && params.search.trim() !== "") {
    searchParams.set("search", params.search.trim());
  }
  if (Array.isArray(params.roleIds) && params.roleIds.length > 0) {
    searchParams.set("roleIds", params.roleIds.join(","));
  }
  if (params.sortField) {
    searchParams.set("sortField", params.sortField);
  }
  if (params.sortDirection) {
    searchParams.set("sortDirection", params.sortDirection);
  }
  const query = searchParams.toString();
  return FetchData(`/api/user${query ? `?${query}` : ""}`, {
    method: "GET",
    signal,
  });
};

export const deleteUserById = (id) =>
  FetchData(`/api/user/${id}`, {
    method: "DELETE",
  });

export const deleteRoleById = (id) =>
  FetchData(`/api/user/user-role/${id}`, {
    method: "DELETE",
  });

export const deleteUsersByIds = (userIds) =>
  FetchData("/api/user", {
    method: "DELETE",
    body: JSON.stringify({ userIds }),
  });

export const fetchUserById = (userId) =>
  FetchData(`/api/user/${userId}`, {
    method: "GET",
  });

export const fetchUserRoleById = (userRoleId) =>
  FetchData(`/api/user/user-role/${userRoleId}`, {
    method: "GET",
  });

export const createUser = (user) =>
  FetchData("/api/user", {
    method: "POST",
    body: JSON.stringify({ user }),
  });

export const updateUser = (userId, user) =>
  FetchData(`/api/user/${userId}`, {
    method: "PUT",
    body: JSON.stringify({ user }),
  });

export const createUserRole = (payload) =>
  FetchData("/api/user/user-role/", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateUserRole = (userRoleId, payload) =>
  FetchData(`/api/user/user-role/${userRoleId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const assignAllPermissionsToRole = (alrData) =>
  FetchData("/api/user/accee-link-role/all", {
    method: "POST",
    body: JSON.stringify({ alr_data: alrData }),
  });

export const updateRolePermissionLink = (acceeLinkRole) =>
  FetchData("/api/user/accee-link-role/", {
    method: "POST",
    body: JSON.stringify({ accee_link_role: acceeLinkRole }),
  });
